import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import './App.css';
import Maps from './Maps';

export default function App() {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // This checks the browser's user agent to see if it's a phone/tablet
    const userAgent = typeof window.navigator === "undefined" ? "" : navigator.userAgent;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

    if (mobileRegex.test(userAgent) || window.innerWidth <= 768) {
      setIsMobile(true);
    }
  }, []);

  const handleDesktopCallClick = () => {
    setShowPopup(true);
  };

  return (
    <div>
      {/* Custom Pop-up Modal using your CSS theme colors */}
      {showPopup && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.75)', zIndex: 9999,
          display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
          <div style={{
            backgroundColor: '#282c34', // Matches your .button and .App-header background
            padding: '40px 20px',
            borderRadius: '8px',
            textAlign: 'center',
            color: '#BA9765', // Matches your gold/tan text color
            maxWidth: '350px', width: '90%',
            boxShadow: '0 8px 16px rgba(0,0,0,0.5)'
          }}>
            <h4 style={{ marginBottom: '15px' }}>Book a table</h4>
            <p style={{ fontSize: '20px', marginBottom: '25px', color: '#BA9765' }}>
              Please call us at:<br />
              <strong style={{ fontSize: '24px' }}>072-233 01 68</strong>
            </p>
            <button
              className="button"
              onClick={() => setShowPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div id="Welcome">

        <nav className="navbar navbar-expand-lg navbar fixed-top  navbar-dark bg-dark">
          <a className="navbar-brand" href="#Welcome">
            <img src="assets/images/logo.jpg" width="75" height="75" className="d-inline-block" alt="" />
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarText">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <a className="nav-link" href="#Welcome">Welcome</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="assets/images/khoiMenu.pdf" alt="mainMenu">Menu</a>
              </li>
              {<li className="nav-item">
                <a className="nav-link" href="assets/images/KhoiLunchMenu.pdf" alt="lunchMenu">Lunch menu</a>
              </li>}
              <li className="nav-item">
                <a className="nav-link" href="https://qopla.com/restaurant/kh%C3%B3i-restaurant/qomEMY2zaK/order">Order takeaway</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.foodora.se/en/restaurant/gst5/khoi-restaurang">Foodora</a>
              </li>
              <li className="nav-item">
                {isMobile ? (
                  <a className="nav-link" href="tel:+46722330168">Book a table</a>
                ) : (
                  <span className="nav-link" style={{ cursor: 'pointer' }} onClick={handleDesktopCallClick}>Book a table</span>
                )}
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#OurLocation">Location</a>
              </li>
            </ul>
          </div>
        </nav>
        <div className="parallax d-flex align-items-center justify-content-center">
          <div className="d-flex align-items-center justify-content-center mw-60">
            <div className="logo">
              <img src="assets/images/logo.png" className="img-fluid" alt="Khoi" />
              <br />
              <br />
              <div className="row">
                <div className="col">
                  <p className="text-center">Follow us:
                    <a className="social-icon" href="https://www.facebook.com/khois.restaurant"><i className="fab fa-facebook-f fa-lg"></i></a>
                    <a className="social-icon" href="https://www.instagram.com/khois.restaurant"><i className="fab fa-instagram fa-lg"></i></a>
                    <a className="social-icon" href="https://www.borascity.se/foretag/khoi-restaurant"><i className="fas fa-bold fa-lg"></i></a></p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
      <div className="container">

        <div className="row rounded-bottom">
          <div className="btn-group-vertical mx-auto" id="Order">
            <br />
            <a href="assets/images/khoiMenu.pdf" alt="Menu" className="button">Menu</a>
            {<a href="assets/images/KhoiLunchMenu.pdf" alt="lunchMenu" className="button">Lunch menu</a>}
            <a href="https://qopla.com/restaurant/kh%C3%B3i-restaurant/qomEMY2zaK/order" className="button eatherePickup">Order take away</a>
            <a href="https://www.foodora.se/en/restaurant/gst5/khoi-restaurang" className="button">Foodora</a>
            {isMobile ? (
              <a href="tel:+46722330168" className="button">Book a table</a>
            ) : (
              <span className="button" style={{ cursor: 'pointer' }} onClick={handleDesktopCallClick}>Book a table</span>
            )}
          </div>
        </div>


        <div className="row" id="Our Story">
          <div className="col navMenu">
            <h2 className="text-center">Our Story</h2>
          </div>
        </div>

        <div className="row rounded">
          <div className="d-grid gap-2 col-8 mx-auto col-xs-1" align="center">
            <br />
            <h5>Khoi' is a  Vietnamese Restaurant offering an array of fresh tasting culinary from scrumptious eats and salads, to heart-warming bowls of “Pho”.
              Our aims bringing to life the overall vision of  the authentic feeling of Vietnam for guests whilst dining at Khoi'.</h5>
            <br />
            <br />
          </div>
        </div>
        <div className="row" id="Happy Hour">
          <div className="col navMenu">
            <h2 className="text-center">Happy Hour</h2>
          </div>
        </div>

        <div className="row rounded">
          <div className="d-grid gap-2 col-8 mx-auto col-xs-1" align="center">
            <br />
            <h5>
              "NHẬU GIỜ NÀY" — our Happy Hour <br />
              <br />
              "Nhậu" is the Vietnamese way of getting together over good food, cold drinks and good friends. <br />
              <br />
              Every Thursday & Friday, 16:00–18:00<br />
              <br />
              Beer, wine, cider 55 kr · cocktails 119 kr · non-alcoholic 49 kr · street bites from 55 kr, and more!<br />
              <br />
              Premiere July 02 — book a table or just drop by. Welcome!<br />
            </h5>
          </div>
        </div>
        <br />
        <div className="row" id="OurLocation">
          <div className="col navMenu">
            <h2 className="text-center">Our location</h2>
          </div>
        </div>

        <div className="row bg-light rounded row justify-content-center">
          <div className="col-md-10 mx-auto">
            <Maps />
          </div>
        </div>
        <br />
        <div className="row bg-dark justify-content-center py-4">

          {/* First Column: Opening Hours */}
          <div className="col-md-5 mb-4 mb-md-0">
            <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', rowGap: '4px', columnGap: '15px' }}>

              {/* Header spans across both columns */}
              <h5 style={{ gridColumn: 'span 2', marginBottom: '8px' }}>OPENING HOURS</h5>

              <span>Monday-Wednesday</span> <span>11:00-20:00</span>
              <span>Thursday & Friday</span> <span>11:00-21:00</span>
              <span>Saturday</span> <span>12:00-21:00</span>
              <span>Sunday</span> <span>Temporarily closed</span>

              {/* Lunch header also spans across both columns */}
              <h5 className="mt-3" style={{ gridColumn: 'span 2', marginBottom: '8px' }}>Lunch</h5>

              <span>Mon-Fri</span> <span>11:00-14:30</span>

            </div>
          </div>

          <div className="col-md-5">
            <h5>Address:</h5>
            <p>Torggatan 31, 50334 Borås</p>
            <h5>Email:</h5>
            <p>khoivietnamesecuisine.res@gmail.com</p>
            <h5>Phone number:</h5>
            <p>072-233 01 68</p>
          </div>

        </div>
      </div>
      <div className="row footer bg-dark">
        <div className="col">
          <p className="text-center">Follow us:
            <a className="social-icon" href="https://www.facebook.com/khois.restaurant"><i className="fab fa-facebook fa-lg"></i></a>
            <a className="social-icon" href="https://www.instagram.com/khois.restaurant"><i className="fab fa-instagram fa-lg"></i></a>
            <a className="social-icon" href="https://www.borascity.se/foretag/khoi-restaurant"><i className="fas fa-bold fa-lg"></i></a></p>
        </div>
      </div>
    </div>
  );
}